import React, { useState } from "react";
import { Table, Modal, Button } from "react-bootstrap";
import CommonActionDropDown from "../commonDropdown";
// import CommonButton from "../commonButton";
import { MoreVerticalIcon } from "../../assets/icons";
import StatusChip from "../statusChip";
import { Link, useLocation } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

const getNestedValue = (obj, path) => {
  if (!path || typeof path !== "string") return "-"; // Prevent crash if path is undefined or not a string
  return (
    path.split(".").reduce((acc, key) => (acc ? acc[key] : null), obj) ?? "-"
  );
};

const DynamicTable = ({
  columns,
  data,
  showActions,
  actions,
  url = null,
  showButton = false,
  onStatusChange,
  moduleName = null,
  draggable,
  onDragEnd,
}) => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const selected_organization_id =
    pathSegments.length > 1 && pathSegments[0] === "organization"
      ? pathSegments[1]
      : null;

  const [openMenuRowIndex, setOpenMenuRowIndex] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState("");

  const handleReadMore = (text) => {
    setModalContent(text);
    setShowModal(true);
  };

  const handleMenuToggle = (rowIndex) => {
    setOpenMenuRowIndex(openMenuRowIndex === rowIndex ? null : rowIndex);
  };

  const generateInfoContent = (row) => {
    const contactName = getNestedValue(row, "contact_name");
    const contactNo = getNestedValue(row, "contact_no");
    const postedUrl = getNestedValue(row, "posted_url");
    const contactEmail = getNestedValue(row, "contact_email");
    const productName = getNestedValue(row, "product.product_name");
    const productCategoryName = getNestedValue(
      row,
      "product.category.category_name"
    );
    const productSubCategoryName = getNestedValue(
      row,
      "product.subcategory.category_name"
    );
    const categoryName = getNestedValue(row, "category.category_name");
    const countryName = getNestedValue(row, "country.name");

    return (
      <div style={{ maxWidth: "500px" }}>
        <div className="mb-3">
          <p
            className="mb-1"
            style={{ margin: "0", fontSize: "14px", width: "300px" }}
          >
            <span style={{ fontWeight: "600" }}> Name : </span>{" "}
            {contactName || "-"}
          </p>
          <p
            className="mb-1"
            style={{ margin: "0", fontSize: "14px", width: "300px" }}
          >
            <span style={{ fontWeight: "600" }}> Mobile Number : </span>{" "}
            {contactNo || "-"}
          </p>
          <p className="mb-1" style={{ margin: "0", fontSize: "14px" }}>
            <span style={{ fontWeight: "600" }}> Email : </span>{" "}
            {contactEmail || "-"}
          </p>
        </div>
        {postedUrl !== "-" && (
          <p className="mb-1" style={{ margin: "0", fontSize: "14px" }}>
            <span style={{ fontWeight: "600" }}> Posted URL : </span>{" "}
            {postedUrl || "-"}
          </p>
        )}
        {productName !== "-" && (
          <>
            <p className="mb-1" style={{ margin: "0", fontSize: "14px" }}>
              <span style={{ fontWeight: "600" }}> Product : </span>{" "}
              {productName || "-"}
            </p>
            {productCategoryName !== "-" && (
              <p className="mb-1" style={{ margin: "0", fontSize: "14px" }}>
                <span style={{ fontWeight: "600" }}> Category : </span>{" "}
                {productCategoryName || "-"}
              </p>
            )}
            {productSubCategoryName !== "-" && (
              <p className="mb-1" style={{ margin: "0", fontSize: "14px" }}>
                <span style={{ fontWeight: "600" }}> Sub Category : </span>{" "}
                {productSubCategoryName || "-"}
              </p>
            )}
          </>
        )}
        {categoryName !== "-" && (
          <p className="mb-1" style={{ margin: "0", fontSize: "14px" }}>
            <span style={{ fontWeight: "600" }}> Category : </span>{" "}
            {categoryName || "-"}
          </p>
        )}
        {countryName !== "-" && (
          <p className="mb-1" style={{ margin: "0", fontSize: "14px" }}>
            <span style={{ fontWeight: "600" }}> Country : </span>{" "}
            {countryName || "-"}
          </p>
        )}
      </div>
    );
  };

  const generatePageInfoContent = (row) => {
    const productName = getNestedValue(row, "product.product_name");
    const categoryName = getNestedValue(row, "category.category_name");

    return (
      <div>
        <p className="mb-1" style={{ margin: "0", fontSize: "14px" }}>
          {`${
            productName && productName !== "-"
              ? "Product Page"
              : categoryName && categoryName !== "-"
              ? "Category Page"
              : "Contact US Page"
          }`}
        </p>
      </div>
    );
  };

  const generateSubCategoriesInfoContent = (row) => {
    const categoryName = getNestedValue(row, "category_name");
    const subCategoryCount = getNestedValue(row, "sub_categories_count");
    const link =
      `/organization/${selected_organization_id}/child-categories/` +
      getNestedValue(row, "id");
    const categoryData = {
      id: getNestedValue(row, "id"),
      category_name: categoryName,
    };

    return (
      <div style={{ maxWidth: "500px" }}>
        {/* <div className='mb-1'>
          <p className='mb-1' style={{ fontSize: "16px", width: "300px" }}>
            <span> {categoryName || "-"} </span> 
          </p>
        </div> */}
        <div className="mb-1">
          <p
            className="mb-1"
            style={{ margin: "0", fontSize: "13px", width: "125px" }}
          >
            <Link
              to={link}
              onClick={(event) => {
                localStorage.setItem(
                  "admin-category-data",
                  JSON.stringify(categoryData)
                );
                event.stopPropagation();
              }}
            >
              {`Child Categories [${subCategoryCount}]`}
            </Link>
          </p>
        </div>
      </div>
    );
  };

  const generateProductsInfoContent = (row) => {
    const categoryName = getNestedValue(row, "category_name");
    const productCount = getNestedValue(row, "product_count");
    const link =
      `/organization/${selected_organization_id}/sub-category-products/` +
      getNestedValue(row, "id");
    const categoryData = {
      id: getNestedValue(row, "id"),
      category_name: categoryName,
    };

    return (
      <div style={{ maxWidth: "500px" }}>
        <div className="mb-1">
          <p
            className="mb-1"
            style={{ margin: "0", fontSize: "13px", width: "125px" }}
          >
            {/* {productCount && productCount !== 0 && productCount !== '-' ? ( */}
            <Link
              to={link}
              onClick={(event) => {
                localStorage.setItem(
                  "admin-sub-category-data",
                  JSON.stringify(categoryData)
                );
                event.stopPropagation();
              }}
            >
              {`Products [${productCount}]`}
            </Link>
            {/* ) : (
                "-"
              )
            } */}
          </p>
        </div>
      </div>
    );
  };

  return (
    <>
      <Table responsive className="common-table">
        <thead>
          <tr>
            {columns.map((column, index) => (
              <th key={index}>{column.label}</th>
            ))}
            {showActions && <th>Actions</th>}
          </tr>
        </thead>

        {draggable && moduleName === "faq" ? (
          <DragDropContext
            onDragEnd={(result) => {
              const { source, destination } = result;

              // If dropped outside the list
              if (!destination || source.index === destination.index) return;

              const reorderedItems = Array.from(data);
              const [movedItem] = reorderedItems.splice(source.index, 1);
              reorderedItems.splice(destination.index, 0, movedItem);

              // Call parent function (e.g. updateFaq) for sequence update
              if (typeof onDragEnd === "function") {
                const updatedItemsWithSequence = reorderedItems.map(
                  (item, index) => ({
                    ...item,
                    sequence: index + 1, // sequence starts from 1
                  })
                );
                onDragEnd(updatedItemsWithSequence); // trigger API update
              }
            }}
          >
            <Droppable droppableId="faq-table-body">
              {(provided) => (
                <tbody ref={provided.innerRef} {...provided.droppableProps}>
                  {data.map((row, rowIndex) => (
                    <Draggable
                      key={row.id}
                      draggableId={String(row.id)}
                      index={rowIndex}
                    >
                      {(provided) => (
                        <tr
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          onClick={() => actions?.onEdit && actions.onEdit(row)}
                          className="cursor-pointer"
                        >
                          {columns.map((column, colIndex) => (
                            <td key={colIndex}>
                              {column.type === "long_text" ? (
                                (() => {
                                  const text = getNestedValue(row, column.key);
                                  return text.length > 30 ? (
                                    <span>
                                      {text.substring(0, 30)}
                                      <div>
                                        <span
                                          style={{
                                            color: "#0d6efd",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => handleReadMore(text)}
                                        >
                                          ... Read More
                                        </span>
                                      </div>
                                    </span>
                                  ) : (
                                    text
                                  );
                                })()
                              ) : column.type === "custom" &&
                                column.key === "info" ? (
                                <div style={{ whiteSpace: "pre-wrap" }}>
                                  {generateInfoContent(row)}
                                </div>
                              ) : column.type === "custom" &&
                                column.key === "pageinfo" ? (
                                <div style={{ whiteSpace: "pre-wrap" }}>
                                  {generatePageInfoContent(row)}
                                </div>
                              ) : column.type === "custom" &&
                                column.key === "subcategoriesinfo" ? (
                                <div style={{ whiteSpace: "pre-wrap" }}>
                                  {generateSubCategoriesInfoContent(row)}
                                </div>
                              ) : column.type === "custom" &&
                                column.key === "productsinfo" ? (
                                <div style={{ whiteSpace: "pre-wrap" }}>
                                  {generateProductsInfoContent(row)}
                                </div>
                              ) : column.type === "image" ? (
                                <img
                                  // src={row[column.key]}
                                  src={getNestedValue(row, column.key)}
                                  alt={column.label}
                                  style={{ maxWidth: "37px", height: "37px" }}
                                />
                              ) : column.type === "date" ? (
                                getNestedValue(row, column.key) === "-" ? (
                                  "-"
                                ) : new Date(
                                    getNestedValue(row, column.key)
                                  ).toLocaleDateString() === "Invalid Date" ? (
                                  "-"
                                ) : (
                                  new Date(getNestedValue(row, column.key))
                                    .toLocaleTimeString("en-IN", {
                                      day: "2-digit",
                                      month: "2-digit",
                                      year: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      // second: '2-digit',
                                      hour12: true,
                                    })
                                    .replace(", ", " ")
                                    .replace(/\//g, "-")
                                    .replace(/(am|pm)$/i, (match) =>
                                      match.toUpperCase()
                                    )
                                )
                              ) : column.type === "status" ? (
                                // row[column.key] === 1 ? (
                                getNestedValue(row, column.key) === true ? (
                                  <StatusChip
                                    bg="chip-green"
                                    title="Active"
                                    className="text-capitalize"
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      onStatusChange && onStatusChange(row);
                                    }}
                                  />
                                ) : (
                                  <StatusChip
                                    bg="chip-red"
                                    title="Deactivate"
                                    className="text-capitalize"
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      onStatusChange && onStatusChange(row);
                                    }}
                                  />
                                )
                              ) : column.type === "status_enquiry" ? (
                                getNestedValue(row, column.key) === true ? (
                                  <StatusChip
                                    bg="chip-green"
                                    title="Open"
                                    className="text-capitalize"
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      onStatusChange && onStatusChange(row);
                                    }}
                                  />
                                ) : (
                                  <StatusChip
                                    bg="chip-red"
                                    title="Close"
                                    className="text-capitalize"
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      onStatusChange && onStatusChange(row);
                                    }}
                                  />
                                )
                              ) : column.type === "default" ||
                                column.type === "primary" ? (
                                getNestedValue(row, column.key) === true ? (
                                  <StatusChip
                                    bg="chip-green"
                                    title="True"
                                    className="text-capitalize"
                                  />
                                ) : (
                                  <StatusChip
                                    bg="chip-red"
                                    title="False"
                                    className="text-capitalize"
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      onStatusChange && onStatusChange(row.id);
                                    }}
                                  />
                                )
                              ) : (
                                // row[column.key]
                                getNestedValue(row, column.key)
                              )}
                            </td>
                          ))}
                          {showActions && (
                            <td
                              onClick={(event) => {
                                event.stopPropagation();
                              }}
                            >
                              <CommonActionDropDown
                                isOpen={openMenuRowIndex === rowIndex}
                                onToggle={() => handleMenuToggle(rowIndex)}
                                icon={
                                  <MoreVerticalIcon
                                    width={20}
                                    height={20}
                                    color="#6D6B77"
                                    strokeWidth="4"
                                  />
                                }
                                firstTitle={actions?.showEdit ? "Edit" : null}
                                firstHref="#"
                                // firstOnClick={() => actions?.onEdit && actions.onEdit(row)}
                                firstOnClick={(event) => {
                                  event.stopPropagation();
                                  actions?.onEdit && actions.onEdit(row);
                                }}
                                secondTitle={actions?.showView ? "View" : null}
                                secondHref="#"
                                // secondOnClick={() => actions?.onView && actions.onView(row)}
                                secondOnClick={(event) => {
                                  event.stopPropagation();
                                  actions?.onView && actions.onView(row);
                                }}
                                // thirdTitle={actions?.showDelete && (moduleName === 'category' ? (row.parent_category_id !== undefined && row.parent_category_id !== null) : true) ? 'Delete' : null}
                                thirdTitle={
                                  actions?.showDelete &&
                                  (moduleName === "category"
                                    ? row.parent_category_id !== undefined &&
                                      row.parent_category_id !== null
                                    : true) &&
                                  (moduleName === "market-area"
                                    ? !row.is_default
                                    : true)
                                    ? "Delete"
                                    : null
                                }
                                thirdHref="#"
                                // thirdOnClick={() => actions?.onDelete && actions.onDelete(row)}
                                thirdOnClick={(event) => {
                                  event.stopPropagation();
                                  actions?.onDelete && actions.onDelete(row);
                                }}
                              />
                            </td>
                          )}
                        </tr>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </tbody>
              )}
            </Droppable>
          </DragDropContext>
        ) : (
          <tbody>
            {data.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                onClick={() => actions?.onEdit && actions.onEdit(row)}
                className="cursor-pointer"
              >
                {columns.map((column, colIndex) => (
                  <td key={colIndex}>
                    {column.type === "long_text" ? (
                      (() => {
                        const text = getNestedValue(row, column.key);
                        return text.length > 30 ? (
                          <span>
                            {text.substring(0, 30)}
                            <div>
                              <span
                                style={{ color: "#0d6efd", cursor: "pointer" }}
                                onClick={() => handleReadMore(text)}
                              >
                                ... Read More
                              </span>
                            </div>
                          </span>
                        ) : (
                          text
                        );
                      })()
                    ) : column.type === "custom" && column.key === "info" ? (
                      <div style={{ whiteSpace: "pre-wrap" }}>
                        {generateInfoContent(row)}
                      </div>
                    ) : column.type === "custom" &&
                      column.key === "pageinfo" ? (
                      <div style={{ whiteSpace: "pre-wrap" }}>
                        {generatePageInfoContent(row)}
                      </div>
                    ) : column.type === "custom" &&
                      column.key === "subcategoriesinfo" ? (
                      <div style={{ whiteSpace: "pre-wrap" }}>
                        {generateSubCategoriesInfoContent(row)}
                      </div>
                    ) : column.type === "custom" &&
                      column.key === "productsinfo" ? (
                      <div style={{ whiteSpace: "pre-wrap" }}>
                        {generateProductsInfoContent(row)}
                      </div>
                    ) : column.type === "image" ? (
                      <img
                        // src={row[column.key]}
                        src={getNestedValue(row, column.key)}
                        alt={column.label}
                        style={{ maxWidth: "37px", height: "37px" }}
                      />
                    ) : column.type === "date" ? (
                      getNestedValue(row, column.key) === "-" ? (
                        "-"
                      ) : new Date(
                          getNestedValue(row, column.key)
                        ).toLocaleDateString() === "Invalid Date" ? (
                        "-"
                      ) : (
                        new Date(getNestedValue(row, column.key))
                          .toLocaleTimeString("en-IN", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            // second: '2-digit',
                            hour12: true,
                          })
                          .replace(", ", " ")
                          .replace(/\//g, "-")
                          .replace(/(am|pm)$/i, (match) => match.toUpperCase())
                      )
                    ) : column.type === "status" ? (
                      // row[column.key] === 1 ? (
                      getNestedValue(row, column.key) === true ? (
                        <StatusChip
                          bg="chip-green"
                          title="Active"
                          className="text-capitalize"
                          onClick={(event) => {
                            event.stopPropagation();
                            onStatusChange && onStatusChange(row);
                          }}
                        />
                      ) : (
                        <StatusChip
                          bg="chip-red"
                          title="Deactivate"
                          className="text-capitalize"
                          onClick={(event) => {
                            event.stopPropagation();
                            onStatusChange && onStatusChange(row);
                          }}
                        />
                      )
                    ) : column.type === "status_enquiry" ? (
                      getNestedValue(row, column.key) === true ? (
                        <StatusChip
                          bg="chip-green"
                          title="Open"
                          className="text-capitalize"
                          onClick={(event) => {
                            event.stopPropagation();
                            onStatusChange && onStatusChange(row);
                          }}
                        />
                      ) : (
                        <StatusChip
                          bg="chip-red"
                          title="Close"
                          className="text-capitalize"
                          onClick={(event) => {
                            event.stopPropagation();
                            onStatusChange && onStatusChange(row);
                          }}
                        />
                      )
                    ) : column.type === "default" ||
                      column.type === "primary" ? (
                      getNestedValue(row, column.key) === true ? (
                        <StatusChip
                          bg="chip-green"
                          title="True"
                          className="text-capitalize"
                        />
                      ) : (
                        <StatusChip
                          bg="chip-red"
                          title="False"
                          className="text-capitalize"
                          onClick={(event) => {
                            event.stopPropagation();
                            onStatusChange && onStatusChange(row.id);
                          }}
                        />
                      )
                    ) : (
                      // row[column.key]
                      getNestedValue(row, column.key)
                    )}
                  </td>
                ))}
                {showActions && (
                  <td
                    onClick={(event) => {
                      event.stopPropagation();
                    }}
                  >
                    <CommonActionDropDown
                      isOpen={openMenuRowIndex === rowIndex}
                      onToggle={() => handleMenuToggle(rowIndex)}
                      icon={
                        <MoreVerticalIcon
                          width={20}
                          height={20}
                          color="#6D6B77"
                          strokeWidth="4"
                        />
                      }
                      firstTitle={actions?.showEdit ? "Edit" : null}
                      firstHref="#"
                      // firstOnClick={() => actions?.onEdit && actions.onEdit(row)}
                      firstOnClick={(event) => {
                        event.stopPropagation();
                        actions?.onEdit && actions.onEdit(row);
                      }}
                      secondTitle={actions?.showView ? "View" : null}
                      secondHref="#"
                      // secondOnClick={() => actions?.onView && actions.onView(row)}
                      secondOnClick={(event) => {
                        event.stopPropagation();
                        actions?.onView && actions.onView(row);
                      }}
                      // thirdTitle={actions?.showDelete && (moduleName === 'category' ? (row.parent_category_id !== undefined && row.parent_category_id !== null) : true) ? 'Delete' : null}
                      thirdTitle={
                        actions?.showDelete &&
                        (moduleName === "category"
                          ? row.parent_category_id !== undefined &&
                            row.parent_category_id !== null
                          : true) &&
                        (moduleName === "market-area" ? !row.is_default : true)
                          ? "Delete"
                          : null
                      }
                      thirdHref="#"
                      // thirdOnClick={() => actions?.onDelete && actions.onDelete(row)}
                      thirdOnClick={(event) => {
                        event.stopPropagation();
                        actions?.onDelete && actions.onDelete(row);
                      }}
                    />
                  </td>
                )}
                {/* {showButton && row.is_default === false && (
                <td style={{ width: '100px' }}>
                  <CommonButton
                    title="Make Default"
                    className="btn-primary common-one-shadow"
                    onClick={() => onStatusChange && onStatusChange(row.id)}
                  />
                </td>
              )} */}
              </tr>
            ))}
          </tbody>
        )}
      </Table>

      <Modal
        size="lg"
        centered
        show={showModal}
        onHide={() => setShowModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>CONTACT MESSAGE</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="my-3">{modalContent}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DynamicTable;
